import childrenPsychotherapyQuestionSet from "../faq/childrenPsychotherapy/allQuestions";

export const psychoterapyChildren = {
    'meta': {
        'title': 'Psychoterapia dzieci i młodzieży #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Psychoterapia dzieci i młodzieży #cityLocativeIn#. Terapia prowadzona przez doświadczonych i wykwalifikowanych terapeutów pracujących w różnych nurtach.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 190,
            'next': 190
        },
        'bydgoszcz': {
            'first': 200,
            'next': 180
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/psychoterapia-dzieci-i-mlodziezy/',
        'title': 'Psychoterapia dzieci i młodzieży #cityLocativeIn#',
        'name': 'Psychoterapia indywidualna dzieci i młodzieży #cityLocativeIn#',
        'heading': 'Psychoterapia indywidualna dzieci i młodzieży #cityLocativeIn#',
        'fullName': 'Psychoterapia indywidualna dzieci i młodzieży'
    },
    'image': {
        'url': '/images/services/psychoterapia-indywidualna-dziecieca.webp',
        'width': 886,
        'height': 295,
        'alt': 'Psychoterapia dzieci i młodzieży'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/psychoterapia-indywidualna-dziecieca.webp',
            'width': 886,
            'height': 295,
            'alt': 'Psychoterapia dzieci i młodzieży'
        }
    },
    'faq': childrenPsychotherapyQuestionSet
}